import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ApprovalCheckbox from './ApprovalCheckbox';
import TicketList from './TicketList';
import CapacityEditor from '../CapacityEditor';
import RecurrentEventTicketModal from './RecurrentEventTicketModal';

import Button from 'ui/Button';
import FormSection from 'ui/FormSection';
import Description from 'ui/text/Description';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const RecurrentEventTickets = ({event, onEventChange, handleDeleteRequest, handleDragEnd, handleRedirect, handleUrlCopy, onChange}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const { sessions, capacity } = event;

  return (
    <FormSection title={"Sessions and Tickets"}>
        {sessions.map((session, index) => (
            <div key={index}>
                <Description bold padded>{session.title}</Description>
                <TicketList
                    tickets={session.tickets}
                    disabled={session.over}
                    handleDeleteRequest={handleDeleteRequest}
                    handleDragEnd={handleDragEnd}
                    handleRedirect={handleRedirect}
                    handleUrlCopy={handleUrlCopy} />
            </div>
        ))}

        <Button
            onClick={() => setModalOpen(true)}
            secondary
            fullwidth
            icon={AddCircleOutlineIcon}
            disabled={event.over}>
                Add New Ticket
        </Button>

        <RecurrentEventTicketModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            event={event}
            onEventChange={onEventChange}
        />

        <ApprovalCheckbox event={event} onChange={onChange} />
        
        <CapacityEditor
            capacity={capacity}
            onChange={onChange} 
            showDivider />

    </FormSection>
  );
};

RecurrentEventTickets.propTypes = {
    event: PropTypes.object,
    onEventChange: PropTypes.func,
    handleDeleteRequest: PropTypes.func,
    handleDragEnd: PropTypes.func,
    handleRedirect: PropTypes.func,
    handleUrlCopy: PropTypes.func,
    onChange: PropTypes.func
};

export default RecurrentEventTickets;